const u = (id, w = 1600) =>
    `https://images.unsplash.com/photo-${id}?q=80&w=${w}&auto=format&fit=crop`;

export const MEDIA = {
    hero: {
        src: u("1603189343302-e603f7add05a", 2400),
        alt: "Model in a wide-sleeved black jacket, silhouetted against a bright studio backdrop",
    },
    intro: {
        src: u("1517502166878-35c93a0072f0", 1200),
        alt: "Clean white hangers on a minimal clothing rail",
    },
    scan: {
        src: u("1650290845943-aa956ec51545", 1600),
        alt: "Street-style look crossing a Copenhagen street lined with bicycles",
    },
    discover: {
        src: u("1780688374822-2cd3c14a7f9d", 1600),
        alt: "Woman walking past a Scandinavian storefront in the city",
    },
    shop: {
        src: u("1775722937069-cfcb7f5dd103", 1600),
        alt: "Woman in a statement coat walking past colourful Copenhagen facades",
    },
    studio: {
        src: u("1747042476734-dc4a41b705c0", 1600),
        alt: "Layered trench coat look on a station platform",
    },
    closet: {
        src: u("1778731660303-1fa5ede75477", 1600),
        alt: "A minimalist rail of curated clothing",
    },
    community: {
        src: u("1708093575609-cf3a3a852605", 1600),
        alt: "A group of people in street style walking a city sidewalk",
    },
    communityTwo: {
        src: u("1763925130516-f570282eeeb8", 1200),
        alt: "Two women walking together on a sunny city street",
    },
    communityThree: {
        src: u("1731021347659-122e1f5e522d", 1200),
        alt: "Woman in a black jacket walking through the city",
    },
};

// Sample catalogue imagery used inside the phone mockups. Swap these for real
// app screenshots when the app ships.
export const PRODUCTS = [
    { id: "p1", src: u("1593764058442-ec2c37d58f80", 600), name: "Oversized Coat", price: "£240" },
    { id: "p2", src: u("1666358065921-a820ef8b65df", 600), name: "Essential Tees", price: "£60" },
    { id: "p3", src: u("1432712641917-22ce322ab531", 600), name: "Court Sneakers", price: "£95" },
    { id: "p4", src: u("1666358068130-13168bbd4d3b", 600), name: "Curated Basics", price: "£75" },
    { id: "p5", src: u("1511556820780-d912e42b4980", 600), name: "Accessory Edit", price: "£120" },
    { id: "p6", src: u("1759572095329-1dcf9522762b", 600), name: "Cotton Tee", price: "£35" },
    { id: "p7", src: u("1576188973526-0e5d7047b0cf", 600), name: "Street Hoodie", price: "£85" },
    { id: "p8", src: u("1661777997192-6b4efeefa0f2", 600), name: "Shoe Archive", price: "£180" },
];
